// +----------------------------------------------------------------------
// | 入口开关组：领体验码 + 下载 App
// |
// | 两个开关的显示条件不一样，这是这个组件存在的唯一理由：
// |   领码 —— 谁都能看到（公众号进来的人第一眼就该看到）
// |   下载 —— 只有「安卓 + 非微信 + 不在App内」才显示（见 lib/platform.js）。
// |           微信里下载会被微信拦（「已停止访问该网页」），所以直接把按钮
// |           藏了。（曾做过一版「点右上角 ⋯ 跳浏览器」引导，用户拍板去掉。）
// |
// | 想要「一排小卡片」的观感，所以做成横排两个格子，和首页快捷入口同风格。
// | 传 variant="plain" 时渲染成列表行（「我的」页用）。
// +----------------------------------------------------------------------
import { Link } from 'react-router-dom';
import { canDownloadApp, APK_URL } from '../../lib/platform';
import './EntrySwitches.less';

export default function EntrySwitches({ variant = 'grid' }) {
  const showDownload = canDownloadApp();

  const handleDownload = () => {
    // 直接给 a 标签点击让浏览器接管下载，别用 window.open ——
    // 部分国产浏览器会把 window.open 当成弹窗拦掉。
    window.location.href = APK_URL;
  };

  if (variant === 'plain') {
    return (
      <div className="card entry-switch-list">
        <Link className="entry-switch-row" to="/free-code">
          <span className="entry-switch-row-icon">🎁</span>
          <span className="entry-switch-row-main">
            <strong>领取体验码</strong>
            <span className="muted">7 天会员 · 公众号领暗号</span>
          </span>
          <span className="entry-switch-row-arrow">›</span>
        </Link>

        {showDownload && (
          <button type="button" className="entry-switch-row" onClick={handleDownload}>
            <span className="entry-switch-row-icon">📱</span>
            <span className="entry-switch-row-main">
              <strong>下载安卓 App</strong>
              <span className="muted">装上就不用每次开浏览器了</span>
            </span>
            <span className="entry-switch-row-arrow">›</span>
          </button>
        )}
      </div>
    );
  }

  // 只剩领码一个入口时不走网格 —— 缩在角落的孤零零一格像个遗忘的占位符。
  // 改成通栏横排行卡（图标 + 文案 + 箭头），和 App 的列表语言一致，看着是有意设计的。
  if (!showDownload) {
    return (
      <Link className="entry-solo" to="/free-code">
        <span className="entry-switch-icon">🎁</span>
        <span className="entry-switch-text">
          <strong>领体验码</strong>
          <i>7 天会员 · 公众号领暗号</i>
        </span>
        <span className="entry-solo-arrow">›</span>
      </Link>
    );
  }

  return (
    <div className="entry-switches">
      <Link className="entry-switch" to="/free-code">
        <span className="entry-switch-icon">🎁</span>
        <span className="entry-switch-text">
          <strong>领体验码</strong>
          <i>7 天会员</i>
        </span>
      </Link>

      <button type="button" className="entry-switch" onClick={handleDownload}>
        <span className="entry-switch-icon">📱</span>
        <span className="entry-switch-text">
          <strong>下载 App</strong>
          <i>安卓版</i>
        </span>
      </button>
    </div>
  );
}
